import { DARK_MODE } from "./dark-mode";

export const AzureAD = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <g id="microsoft-icon 1" clipPath="url(#clip0_2115_8900)">
      <path id="Vector" d="M0 0H7.6031V7.6031H0V0Z" fill="#F25022" />
      <path id="Vector_2" d="M8.39691 0H16V7.6031H8.39691V0Z" fill="#7FBA00" />
      <path id="Vector_3" d="M0 8.3969H7.6031V16H0V8.3969Z" fill="#00A4EF" />
      <path
        id="Vector_4"
        d="M8.39691 8.3969H16V16H8.39691V8.3969Z"
        fill="#FFB900"
      />
    </g>
    <defs>
      <clipPath id="clip0_2115_8900">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
